<template>
  <div>
    <div @click.prevent="show()">
      <slot>
        <div>GetQuotes</div>
      </slot>
    </div>

    <vue-modal
      v-if="isModalVisible"
      modal_title="Post a Task"
      container_style="min-width:50%;height:370px;overflow:hidden;text-align:left;margin-top:100px;position:relative;z-index:999;"
      body_container_style="min-width:50%;height:370px;overflow:hidden;"
      @close="hide"
    >
      <template v-slot:header>
        <div class="modaltitleheader">
          <h4>Request a Quotes</h4>
        </div>
      </template>
      <template v-slot:body>
        <div style="display: flex;flex-flow: column;align-items: center;">
          <label v-if="api_token" style="align-self: self-start;">Please select a task</label>
          <label v-else style="align-self: self-start;">Login for select a task / Create a new task</label>
          <multiselect
            v-model="task"
            :searchable="true"
            :loading="isLoading"
            :options="tasks"
            placeholder="Please select a task"
            :clearOnSelect="false"
            :closeOnSelect="true"
            :preserveSearch="true"
            label="title"
            track-by="title"
          >
            <template slot="singleLabel" slot-scope="props">
              <div
                class="mr-1"
                style="font-size: 14px;white-space: nowrap;overflow: hidden;"
              >{{ props.option.title }}</div>
            </template>
            <template slot="option" slot-scope="props">
              <div
                class="mr-1"
                style="font-size: 14px;white-space: nowrap;overflow: hidden;"
              >{{ props.option.title }}</div>
            </template>
          </multiselect>
          <div style="margin:20px 0;">Or</div>
          <get-quotes
            @click="hide"
            :show_btn="true"
            :category_id="categoryId"
            :suburb_id="suburbId"
            :signin="signin"
            redirect_url
            @getTask="getTask"
          >
            <a href class="btn btn-link">Create a new task</a>
          </get-quotes>
        </div>
      </template>
      <template v-slot:footer>
        <div
          @click="requestQuotes()"
          v-if="enableRequestQuotesBtn"
          class="btn btn-primary"
        >Request Quotes</div>
        <div v-else class="btn btn-primary">Request Quotes</div>
      </template>
    </vue-modal>
  </div>
</template>

<script>
import VueModal from "./../VueModal";
import GetQuotes from "./../front/task/GetQuotes";
import Multiselect from "vue-multiselect";
export default {
  components: {
    GetQuotes,
    VueModal,
    Multiselect
  },
  props: {
    signin: {
      type: Boolean,
      default: false
    },
    trader_id: {
      type: [String, Number],
      required: true
    },
    category_id: {
      type: [String, Number]
    },
    suburb_id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      categoryId: this.category_id,
      suburbId: this.suburb_id,
      traderId: this.trader_id,
      isModalVisible: false,
      createNewTask: false,
      tasks: [],
      task: null,
      isLoading: false,
      api_token: null,
      enableRequestQuotesBtn: true
    };
  },
  created() {
    if (
      window.api_token != undefined &&
      window.api_token != null &&
      window.api_token != ""
    ) {
      this.api_token = window.api_token;
      this.getAllTask();
    }
  },
  methods: {
    getAllTask() {
      let self = this;
      self.$Progress.start();
      self.isLoading = true;
      axios({
        method: "get",
        url: `/api/v1/task/get-user-todo-tasks?api_token=${self.api_token}`
      })
        .then(function(response) {
          self.isLoading = false;
          self.$Progress.finish();
          if (response.data.ok) {
            self.tasks = response.data.data;
          }
        })
        .catch(function(err) {
          self.isLoading = false;
          self.$Progress.fail();
          self.errors = err.response.data.errors;
        });
    },
    getTask(task) {
      this.task = task;
      if (
        window.api_token != undefined &&
        window.api_token != null &&
        window.api_token != ""
      ) {
        this.api_token = window.api_token;
        this.getAllTask();
      }
    },
    requestQuotes() {
      if (this.task == null || this.task == undefined) {
        this.$toast.error("Please select a task or create a new task");
      } else {
        let self = this;
        self.$Progress.start();
        self.enableRequestQuotesBtn = false;
        let data = {
          task_id: self.task.id,
          trader_id: self.trader_id
        };
        axios({
          method: "post",
          url: "/api/v1/request-quotes?api_token=" + self.api_token,
          data
        })
          .then(function(response) {
            self.$Progress.finish();
            if (response.data.ok) {
              self.$toast.success(response.data.msg);
            }
            self.enableRequestQuotesBtn = true;
          })
          .catch(function(err) {
            self.enableRequestQuotesBtn = true;
            self.$Progress.fail();
            console.log(err);
          });
      }
    },
    show() {
      this.isModalVisible = true;
    },
    hide() {
      this.isModalVisible = false;
    }
  }
};
</script>
